import React, {useState} from 'react';
import {Alert, Button, Col} from 'antd';
import {FormattedMessage, useIntl} from 'react-intl';
import {accessibilityRoles} from "../../utils/accessUtils";
import AccessControl from "../common/AccessControl";
import ClinicSearchForm from "./ClinicSearchFrom";
import ClinicGeneralCard from "./cards/ClinicGeneralCard";

const MedicalHistory = () => {

    const intl = useIntl();
    const [toothTab, setToothTab] = useState(0);
    const [keyword, setKeyword] = useState<string>('');
    const [isIllnessModalVisible, setIsIllnessModalVisible] = useState(false);
    const [isAllergyModalVisible, setIsAllergyModalVisible] = useState(false);
    const [isMedicationModalVisible, setIsMedicationModalVisible] = useState(false);

    const closeModal = () => {
        setIsIllnessModalVisible(false);
        setIsAllergyModalVisible(false);
        setIsMedicationModalVisible(false);
    };


    const onAddButtonClick = () => {
        if (toothTab === 0) {
            setIsIllnessModalVisible(true);
        } else if (toothTab === 1) {
            setIsAllergyModalVisible(true);
        } else if (toothTab === 2) {
            setIsMedicationModalVisible(true);
        }
    };

    const renderCard = () => {
        if (toothTab === 0) {
            return <ClinicGeneralCard type="ILLNESS" showModal={isIllnessModalVisible} onClose={() => closeModal()}
                                      keyword={keyword}/>;
        } else if (toothTab === 1) {
            return <ClinicGeneralCard type="ALLERGY" showModal={isAllergyModalVisible} onClose={() => closeModal()}
                                      keyword={keyword}/>;
        } else if (toothTab === 2) {
            return <ClinicGeneralCard type="MEDICATION" showModal={isMedicationModalVisible}
                                      onClose={() => closeModal()}
                                      keyword={keyword}/>;
        }
    }

    return (

        <AccessControl
            accessibleFor={[accessibilityRoles.CLINIC_ADMIN, accessibilityRoles.MEDICAL_DOCTOR, accessibilityRoles.MEDICAL_ASSISTANT, accessibilityRoles.RECEPTIONIST, accessibilityRoles.DENTAL_TECHNICIAN]}>
            <Col>
                <ClinicSearchForm
                    keyword={keyword}
                    setKeyword={setKeyword}
                    loadData={() => {
                    }}
                    onAddButtonClick={onAddButtonClick}
                />
            </Col>

            <div className="dentobook-content">
                <div style={{display: 'flex', height: '10%'}}>
                    <Button className="tooth-status-btn"
                            type={toothTab === 0 ? "primary" : "default"}
                            onClick={() => setToothTab(0)}><FormattedMessage
                        id="illnesses"/></Button>
                    <Button className="medical-history-allergy-btn"
                            type={toothTab === 1 ? "primary" : "default"}
                            onClick={() => setToothTab(1)}><FormattedMessage
                        id="allergies"/></Button>
                    <Button className="tooth-plan-btn"
                            type={toothTab === 2 ? "primary" : "default"}
                            onClick={() => setToothTab(2)}>
                        <FormattedMessage id="medications"/>
                    </Button>
                </div>
                <Alert
                    message={intl.formatMessage({id: 'medical_history_info'})}
                    type="info"
                    showIcon
                    style={{marginTop: 16, marginBottom: 16}}
                />
                {renderCard()}
            </div>
        </AccessControl>
    );
};

export default MedicalHistory;
